import Box from "@mui/material/Box";
import Hidden from "@mui/material/Hidden";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { YSButton } from "../../uikit/YSButton";
import { useEffect, useRef, useState } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { ErrorMessage, Form, Formik } from "formik";
import * as yup from "yup";
import {
  warnColor,
  InputSMBoxStyle,
  DatePickerField,
  BtnSMGroupStyle,
  ContentStyle,
  DRxInputStyle,
  DRxSelectStyle,
  TelephoneStyle,
} from "../../Theme";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import ProfileTabsNav from "../../components/ProfileTabsNav";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import DRxInput from "../../uikit/DRxInput";
import DRxSelect from "../../uikit/DRxSelect";
import { DRxSelect2 } from "../../uikit/DRxSelect2";
import { useDispatch, useSelector } from "react-redux";
import useFetch from "../../CustomHooks/useFetch";
import {
  PatientProfilePI,
  PatientProfilePIUpdate,
} from "../../Apis/AuthApiServices";
import { DialogPopup } from "../../components/DialogPopup";
import YSSnackBar from "../../uikit/YSSnackBar";
import { loadingPatientDetails } from "../../Redux/Slice/PatientDetailsSlice";

const initialStatePatientProfile = {
  patientId: "",
  telHomeCode: "",
  telHomeNo1: "",
  telHomeNo2: "",
  telWorkCode: "",
  telWorkNo1: "",
  telWorkNo2: "",
  firstName: "",
  middleName: "",
  lastName: "",
  gender: "",
  prefix: "",
  suffix: "",
  dateOfBirth: "",
  height: "",
  weight: "",
  email: "",
  confirmEmail: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  country: "",
  zip: "",
  consent: "",
  detailedPersonDTO: "",
  noActiveMedsReported: false,
  consentOptions: [],
  countrySelection: [],
  genderSelection: [],
  HealthCondition: "",
  AllergicTo: "",
};

export default function PatientProfile(props: any) {
  const home2Ref = useRef<any>(null);
  const home3Ref = useRef<any>(null);
  const work2Ref = useRef<any>(null);
  const work3Ref = useRef<any>(null);
  const AllDropdwonsState = useSelector((state: any) => {
    return { ...state.GlobalDropdownSlice.DropdownLists };
  }); //redux data
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  const [patientProfileData, setPatientProfileData] = useState(
    initialStatePatientProfile
  );
  const dispatch = useDispatch();
  const [stateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const [registerPopUP, setregisterPopUP] = useState(false);
  const handleShowApprovedPopupClick = () => {
    setregisterPopUP(true);
  };
  const handleHideApprovedPopupClick = () => {
    setregisterPopUP(false);
  };
  const [registerStateData, setRegisterStateData] = useState("");
  const patientId = sessionStorage.getItem("patientId");
  const ParamsData = {
    patientId: patientId,
  };
  const { data, loading, fetchApi }: any = useFetch(
    ParamsData,
    PatientProfilePI,
    []
  );

  useEffect(() => {
    if (data[0]) {
      setPatientProfileData(data[0]);
    }
  }, [data]);

  const SubmitPatientProfile = async (values: any) => {
    try {
      const bodyData = {
        patientId: values.patientId ?? "",
        telHomeCode: values.telHomeCode ?? "",
        telHomeNo1: values.telHomeNo1 ?? "",
        telHomeNo2: values.telHomeNo2 ?? "",
        telWorkCode: values.telWorkCode ?? "",
        telWorkNo1: values.telWorkNo1 ?? "",
        telWorkNo2: values.telWorkNo2 ?? "",
        firstName: values.firstName ?? "",
        middleName: values.middleName ?? "",
        lastName: values.lastName ?? "",
        gender: values.gender ?? "",
        prefix: values.prefix ?? "",
        suffix: values.suffix ?? "",
        dateOfBirth: values.dateOfBirth ?? "",
        email: values.email ?? "",
        confirmEmail: values.confirmEmail ?? "",
        consent: values.consent ?? "",
        address1: values.address1 ?? "",
        address2: values.address2 ?? "",
        city: values.city ?? "",
        state: values.state === "Select State" ? "" : values.state ?? "",
        country: values.country ?? "",
        zip: values.zip ?? "",
        weight: values.weight ?? "",
        height: values.height ?? "",
      };
      const result = await PatientProfilePIUpdate(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setRegisterStateData(result?.data?.response[0]?.message);
        handleShowApprovedPopupClick();
        dispatch(loadingPatientDetails());
      } else {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err) {
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After SomeTime!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const calculateAge = (dob: any) => {
    const dateOfBirth = moment(dob, "MM/DD/YYYY");
    const age = moment().diff(dateOfBirth, "years");
    return age;
  };

  return (
    <>
      <ProfileTabsNav />
      <ContentStyle>
        <Typography
          className="help"
          component="h6"
          color="primary"
          variant="h6"
        >
          Patient Profile{" "}
          <HelpGuideTooltip
            content={
              <>
                <Typography component="div" variant="body1">
                  The patient personnel information is shown in this section.
                </Typography>
              </>
            }
          />
        </Typography>
        {loading ? (
          <Grid
            container
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            height={"50vh"}
          >
            <CircularProgress color="primary" />
          </Grid>
        ) : (
          <Formik
            initialValues={patientProfileData}
            validationSchema={yup.object().shape({
              firstName: yup
                .string()
                .matches(
                  /^[a-zA-Z!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/? ]*$/,
                  "First name should be alphabetic characters."
                )
                .required("First name is required")
                .max(32)
                .min(1),
              lastName: yup
                .string()
                .matches(
                  /^[a-zA-Z!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/? ]*$/,
                  "Last name should be alphabetic characters."
                )
                .required("Last name is required")
                .max(32)
                .min(1),
              middleName: yup.string().min(0).max(16),
              address1: yup.string().required("Address is required"),
              city: yup.string().required("City is required"),
              state: yup.string().required("State is required"),
              dateOfBirth: yup
                .date()
                .nullable()
                .required("Date of Birth is required")
                .typeError("Date of Birth is required"),
              height: yup
                .string()
                .nullable()
                .when("dateOfBirth", {
                  is: (val: any) => calculateAge(val) >= 18,
                  then: yup.string().notRequired().nullable(),
                  otherwise: yup
                    .string()
                    .required("Height is required")
                    .nullable(),
                })
                .matches(/^[0-9]+$/, "Height should be in number."),
              weight: yup
                .string()
                .nullable()
                .when("dateOfBirth", {
                  is: (val: any) => calculateAge(val) >= 18,
                  then: yup.string().notRequired().nullable(),
                  otherwise: yup
                    .string()
                    .required("Weight is required")
                    .nullable(),
                })
                .matches(/^[0-9]+$/, "Weight should be in number."),
              gender: yup.string().required("Gender is required"),
              zip: yup
                .string()
                .required("Zip is required")
                .min(5)
                .max(5)
                .matches(/^[0-9]+$/, "Invalid zip."),
              email: yup.string().nullable(),
              confirmEmail: yup
                .string()
                .oneOf([yup.ref("email"), null], "Invalid email id.")
                .nullable(),
            })}
            enableReinitialize={true}
            onSubmit={(values) => {
              SubmitPatientProfile(values);
            }}
          >
            {(registerProps) => (
              <Form onSubmit={registerProps.handleSubmit}>
                <Grid
                  container
                  xs={12}
                  spacing={0}
                  alignItems="top"
                  columnSpacing={2}
                >
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="lastname"
                      >
                        Last Name
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="lastname"
                            name="lastName"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.lastName}
                            onChange={registerProps.handleChange}
                            onBlur={registerProps.handleBlur}
                            error={
                              registerProps.touched.lastName &&
                              Boolean(registerProps.errors.lastName)
                            }
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="middlename"
                        className="mr"
                      >
                        Middle Name
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="middlename"
                            name="middleName"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.middleName}
                            onChange={registerProps.handleChange}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="firstname"
                      >
                        First Name
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="firstname"
                            name="firstName"
                            type="text"
                            className="input"
                            disabled={false}
                            value={registerProps.values.firstName}
                            onChange={registerProps.handleChange}
                            onBlur={registerProps.handleBlur}
                            error={
                              registerProps.touched.firstName &&
                              Boolean(registerProps.errors.firstName)
                            }
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Hidden mdDown>
                    <Grid item xs={12} md={6}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          variant="body2"
                          htmlFor="prefix"
                          className="mr"
                        >
                          Prefix
                        </Typography>
                        <Box className="nested">
                          <DRxInputStyle>
                            <DRxInput
                              id="prefix"
                              name="prefix"
                              type="text"
                              className=""
                              disabled={false}
                              onChange={registerProps.handleChange}
                              value={registerProps.values.prefix}
                            />
                          </DRxInputStyle>
                          <Box className="nested">
                            <Typography
                              component="label"
                              variant="body2"
                              htmlFor="suffix"
                              className="mr suffix"
                            >
                              Suffix
                            </Typography>
                            <Box className="nested">
                              <DRxInputStyle>
                                <DRxInput
                                  id="suffix"
                                  name="suffix"
                                  type="text"
                                  className=""
                                  disabled={false}
                                  value={registerProps.values.suffix}
                                  onChange={registerProps.handleChange}
                                />
                              </DRxInputStyle>
                              <Typography
                                component="div"
                                variant="body2"
                                className="info"
                              >
                                MD, PhD etc
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                  </Hidden>
                  <Hidden mdUp>
                    <Grid item xs={12}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          variant="body2"
                          htmlFor="prefix"
                        >
                          Prefix
                        </Typography>
                        <Box>
                          <DRxInputStyle>
                            {" "}
                            <DRxInput
                              id="prefix"
                              name="prefix"
                              type="text"
                              className=""
                              disabled={false}
                              onChange={registerProps.handleChange}
                              value={registerProps.values.prefix}
                            />
                          </DRxInputStyle>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          variant="body2"
                          htmlFor="suffix"
                        >
                          Suffix
                        </Typography>
                        <Box>
                          <DRxInputStyle>
                            {" "}
                            <DRxInput
                              id="suffix"
                              name="suffix"
                              type="text"
                              className=""
                              disabled={false}
                              value={registerProps.values.suffix}
                              onChange={registerProps.handleChange}
                            />
                          </DRxInputStyle>
                          <Typography
                            component="div"
                            variant="body2"
                            className="info"
                          >
                            MD, PhD etc
                          </Typography>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                  </Hidden>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="gender"
                      >
                        Gender
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>
                      <Box>
                        <DRxSelectStyle>
                          <DRxSelect
                            name="gender"
                            id="gender"
                            data={
                              patientProfileData?.genderSelection ?? [
                                { label: "", value: "" },
                              ]
                            }
                          />
                        </DRxSelectStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="dateofB"
                        className="mr"
                      >
                        Date of Birth
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>

                      <Box>
                        <DatePickerField>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              inputFormat="MM/dd/yyyy"
                              value={registerProps.values.dateOfBirth}
                              onChange={(e) => {
                                if (e === null) {
                                  registerProps.setFieldValue(
                                    "dateOfBirth",
                                    ""
                                  );
                                } else {
                                  registerProps.setFieldValue(
                                    "dateOfBirth",
                                    moment(e).format("MM/DD/yyyy")
                                  );
                                }
                              }}
                              renderInput={(params) => (
                                <>
                                  <TextField
                                    name="dateOfBirth"
                                    {...params}
                                    error={
                                      registerProps.touched.dateOfBirth &&
                                      Boolean(registerProps.errors.dateOfBirth)
                                    }
                                  />
                                  <Typography
                                    color="error"
                                    className="error"
                                    variant="body2"
                                    component="div"
                                  >
                                    <ErrorMessage name="dateOfBirth" />
                                  </Typography>
                                </>
                              )}
                            />
                          </LocalizationProvider>
                        </DatePickerField>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="address"
                      >
                        Address
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="address"
                            name="address1"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.address1}
                            onChange={registerProps.handleChange}
                            error={
                              registerProps.touched.address1 &&
                              Boolean(registerProps.errors.address1)
                            }
                          />{" "}
                        </DRxInputStyle>
                        <DRxInputStyle marginTop={1}>
                          <DRxInput id="address" name="address2" type="text" />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="country"
                        className="mr"
                      >
                        Country
                      </Typography>
                      <Box>
                        <DRxSelectStyle>
                          <DRxSelect2
                            name="country"
                            id="country"
                            options={
                              patientProfileData?.countrySelection ?? [
                                { value: "", label: "" },
                              ]
                            }
                            onChange={(option: any, e: any) => {
                              registerProps.setFieldValue(
                                "country",
                                e.props.value
                              );
                            }}
                            value={registerProps.values.country}
                          />
                        </DRxSelectStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="state"
                      >
                        State
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>
                      <Box>
                        <DRxSelectStyle>
                          <DRxSelect2
                            name="state"
                            id="state"
                            options={
                              AllDropdwonsState?.statesOptions ?? [
                                { label: "", value: "" },
                              ]
                            }
                            onChange={(option: any, e: any) => {
                              registerProps.setFieldValue(
                                "state",
                                e.props.value
                              );
                            }}
                            value={registerProps.values.state}
                          />
                        </DRxSelectStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="city"
                        className="mr"
                      >
                        City
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          {" "}
                          <DRxInput
                            id="city"
                            name="city"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.city}
                            onChange={registerProps.handleChange}
                            onBlur={registerProps.handleBlur}
                            error={
                              registerProps.touched.city &&
                              Boolean(registerProps.errors.city)
                            }
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="zip"
                      >
                        Zip
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          {" "}
                          <DRxInput
                            id="zip"
                            name="zip"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.zip}
                            onChange={registerProps.handleChange}
                            onBlur={registerProps.handleBlur}
                            error={
                              registerProps.touched.zip &&
                              Boolean(registerProps.errors.zip)
                            }
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="email"
                        className="mr"
                      >
                        E-mail
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          {" "}
                          <DRxInput
                            id="email"
                            name="email"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.email}
                            onChange={registerProps.handleChange}
                            onBlur={registerProps.handleBlur}
                            error={
                              registerProps.touched.email &&
                              Boolean(registerProps.errors.email)
                            }
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="email"
                      >
                        Confirm E-mail
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          {" "}
                          <DRxInput
                            id="Cemail"
                            name="confirmEmail"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.confirmEmail}
                            onChange={registerProps.handleChange}
                            onBlur={registerProps.handleBlur}
                            error={
                              registerProps.touched.confirmEmail &&
                              Boolean(registerProps.errors.confirmEmail)
                            }
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="consent"
                        className="mr"
                      >
                        Consent
                      </Typography>
                      <Box>
                        <DRxSelectStyle>
                          <DRxSelect2
                            name="consent"
                            id="consent"
                            options={
                              patientProfileData?.consentOptions ?? [
                                { value: "", label: "" },
                              ]
                            }
                            onChange={(option: any, e: any) => {
                              registerProps.setFieldValue(
                                "consent",
                                e.props.value
                              );
                            }}
                            value={registerProps.values.consent}
                          />
                        </DRxSelectStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6} marginBottom={1}>
                    <InputSMBoxStyle>
                      <Typography component="label" variant="body2">
                        Telephone No.(Home)
                      </Typography>{" "}
                      <Box>
                        <TelephoneStyle>
                          <DRxInput
                            id="telHomeCode"
                            name="telHomeCode"
                            type="number"
                            className=""
                            placeholder="Code"
                            value={registerProps.values.telHomeCode ?? ""}
                            onChange={(event: any) => {
                              registerProps.setFieldValue(
                                "telHomeCode",
                                event.target.value.slice(0, 3)
                              );
                              if (event.target.value.length === 3) {
                                home2Ref?.current?.focus();
                              }
                            }}
                          />{" "}
                          <DRxInput
                            id="telHomeNo1"
                            name="telHomeNo1"
                            type="number"
                            className=""
                            inputRef={home2Ref}
                            value={registerProps.values.telHomeNo1 ?? ""}
                            placeholder="NO1"
                            onChange={(event: any) => {
                              registerProps.setFieldValue(
                                "telHomeNo1",
                                event.target.value.slice(0, 3)
                              );
                              if (event.target.value.length === 3) {
                                home3Ref?.current?.focus();
                              }
                            }}
                          />
                          <DRxInput
                            id="telHomeNo2"
                            name="telHomeNo2"
                            type="number"
                            className=""
                            inputRef={home3Ref}
                            placeholder={"NO2"}
                            value={registerProps.values.telHomeNo2 ?? ""}
                            onChange={(event: any) => {
                              registerProps.setFieldValue(
                                "telHomeNo2",
                                event.target.value.slice(0, 4)
                              );
                            }}
                          />
                        </TelephoneStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6} marginBottom={1}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        className="mr"
                      >
                        Telephone No.(Work)
                      </Typography>{" "}
                      <Box>
                        <TelephoneStyle>
                          <DRxInput
                            id="telWorkCode"
                            name="telWorkCode"
                            type="number"
                            className=""
                            placeholder="Code"
                            value={registerProps.values.telWorkCode ?? ""}
                            onChange={(event: any) => {
                              registerProps.setFieldValue(
                                "telWorkCode",
                                event.target.value.slice(0, 3)
                              );
                              if (event.target.value.length === 3) {
                                work2Ref?.current?.focus();
                              }
                            }}
                          />{" "}
                          <DRxInput
                            id="telWorkNo1"
                            name="telWorkNo1"
                            type="number"
                            className=""
                            placeholder="NO1"
                            inputRef={work2Ref}
                            value={registerProps.values.telWorkNo1 ?? ""}
                            onChange={(event: any) => {
                              registerProps.setFieldValue(
                                "telWorkNo1",
                                event.target.value.slice(0, 3)
                              );
                              if (event.target.value.length === 3) {
                                work3Ref?.current?.focus();
                              }
                            }}
                          />
                          <DRxInput
                            id="telWorkNo2"
                            name="telWorkNo2"
                            type="number"
                            className=""
                            inputRef={work3Ref}
                            placeholder={"NO2"}
                            value={registerProps.values.telWorkNo2 ?? ""}
                            onChange={(event: any) => {
                              registerProps.setFieldValue(
                                "telWorkNo2",
                                event.target.value.slice(0, 4)
                              );
                            }}
                          />
                        </TelephoneStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="Weight"
                      >
                        Weight (lbs(rounded))
                      </Typography>
                      <Box>
                        <DRxInputStyle>
                          {" "}
                          <DRxInput
                            id="Weight"
                            name="weight"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.weight}
                            onChange={registerProps.handleChange}
                            onBlur={registerProps.handleBlur}
                            error={
                              registerProps.touched.weight &&
                              Boolean(registerProps.errors.weight)
                            }
                          />
                        </DRxInputStyle>
                        <Typography
                          component="div"
                          variant="body2"
                          className="info"
                        >
                          Enter Weight only in lbs(rounded), no text & special
                          characters allowed
                        </Typography>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="Height"
                        className="mr"
                      >
                        Height (Inches)
                      </Typography>
                      <Box>
                        <DRxInputStyle>
                          {" "}
                          <DRxInput
                            id="Height"
                            name="height"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.height}
                            onChange={registerProps.handleChange}
                            onBlur={registerProps.handleBlur}
                            error={
                              registerProps.touched.height &&
                              Boolean(registerProps.errors.height)
                            }
                          />
                        </DRxInputStyle>
                        <Typography
                          component="div"
                          variant="body2"
                          className="info mm"
                        >
                          Enter Height only in Inches, no text & special
                          characters allowed (ex:Enter 38 Inches if patient
                          height is 3feet 2inches)
                        </Typography>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  {/* <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="allergic"
                      >
                        Allergic To
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          {" "}
                          <DRxInput
                            id="allergic"
                            name="AllergicTo"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.AllergicTo}
                            onChange={registerProps.handleChange} 
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>{" "} */}
                  <Grid item xs={12} md={6}></Grid>
                  {/* <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="health"
                      >
                        Health Condition
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          {" "}
                          <DRxInput
                            id="health"
                            name="HealthCondition"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.HealthCondition}
                            onChange={registerProps.handleChange} 
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid> */}
                  {!UserServiceState?.disablePatientEditAndRegisterFlag && (
                    <Grid item xs={12} md={6} marginTop={5}>
                      <BtnSMGroupStyle>
                        <YSButton
                          size="large"
                          className=""
                          color="primary"
                          dataTestId="submitBtn"
                          variant="contained"
                          disabled={false}
                          type="submit"
                          children={"Update"}
                          onClick={null}
                        />
                      </BtnSMGroupStyle>
                    </Grid>
                  )}
                </Grid>
              </Form>
            )}
          </Formik>
        )}
      </ContentStyle>
      <DialogPopup
        windowsize={"sm"}
        show={registerPopUP}
        handleShowPopupClick={handleShowApprovedPopupClick}
        handleHidePopupClick={handleHideApprovedPopupClick}
      >
        <Grid
          container
          xs={12}
          alignItems="center"
          justifyContent="center"
          marginTop={2}
          rowSpacing={2}
        >
          <Grid item xs={12} textAlign={"center"}>
            <CheckCircleOutlineIcon
              style={{ height: 70, width: 70 }}
              color="success"
            />
          </Grid>
          <Grid item xs={12} textAlign={"center"}>
            <Typography component="span" variant="subtitle1" fontWeight={600}>
              Successfully {registerStateData}
            </Typography>{" "}
          </Grid>
          <Grid item xs={12} textAlign={"center"}>
            <YSButton
              color="primary"
              children={"Back"}
              onClick={() => {
                handleHideApprovedPopupClick();
                fetchApi();
              }}
              variant={"contained"}
              size={"large"}
            />
          </Grid>{" "}
        </Grid>{" "}
      </DialogPopup>
      <YSSnackBar
        message={stateData.message}
        variant={stateData.variant}
        open={stateData.open}
        handleClose={() => {
          setStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
